// extracted by mini-css-extract-plugin
module.exports = {"BlackButton":"BlackButton_BlackButton__jw0ye"};